"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFieldRequired = exports.validator = exports.RANGE = exports.LIST = exports.MATCH_PATTERN = exports.INTEGER = exports.STRING = exports.PASSWORD_COMPLEXITY = exports.COMPARE = exports.EMAIL = exports.REQUIRED = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _value = require("skybase-ui/skybase-core/utils/value");

// import isEmpty from 'lodash/isEmpty'
var _REQUIRED$COMPARE$EMA = {
  REQUIRED: 'required',
  COMPARE: 'compare',
  EMAIL: 'email',
  PASSWORD_COMPLEXITY: 'password-complexity',
  STRING: 'string',
  INTEGER: 'integer',
  MATCH_PATTERN: 'match-pattern',
  LIST: 'list',
  RANGE: 'range'
},
    REQUIRED = _REQUIRED$COMPARE$EMA.REQUIRED,
    EMAIL = _REQUIRED$COMPARE$EMA.EMAIL,
    COMPARE = _REQUIRED$COMPARE$EMA.COMPARE,
    PASSWORD_COMPLEXITY = _REQUIRED$COMPARE$EMA.PASSWORD_COMPLEXITY,
    STRING = _REQUIRED$COMPARE$EMA.STRING,
    INTEGER = _REQUIRED$COMPARE$EMA.INTEGER,
    MATCH_PATTERN = _REQUIRED$COMPARE$EMA.MATCH_PATTERN,
    LIST = _REQUIRED$COMPARE$EMA.LIST,
    RANGE = _REQUIRED$COMPARE$EMA.RANGE;
exports.RANGE = RANGE;
exports.LIST = LIST;
exports.MATCH_PATTERN = MATCH_PATTERN;
exports.INTEGER = INTEGER;
exports.STRING = STRING;
exports.PASSWORD_COMPLEXITY = PASSWORD_COMPLEXITY;
exports.COMPARE = COMPARE;
exports.EMAIL = EMAIL;
exports.REQUIRED = REQUIRED;

var required = function required(value, attribute, message) {
  var getMessage = typeof message === 'function' ? message(attribute, value) : message;
  var isEmpty = (0, _value.isNullOrUndefined)(value) || value === '' || value.trim && value.trim() === '' || !(0, _value.isNullOrUndefined)(value.length) && value.length === 0;
  return isEmpty ? getMessage : null;
};

var email = function email(value, attribute, message) {
  // eslint-disable-next-line no-useless-escape
  var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  var getMessage = typeof message === 'function' ? message(attribute, value) : message;
  return !regex.test(value) ? getMessage : null;
};

var compare = function compare(_ref, _ref2, message) {
  var value1 = _ref.value1,
      value2 = _ref.value2;
  var attribute1 = _ref2.attribute1,
      attribute2 = _ref2.attribute2;
  var getMessage = typeof message === 'function' ? message({
    attribute1: attribute1,
    attribute2: attribute2
  }, {
    value1: value1,
    value2: value2
  }) : message;
  return value1 !== value2 ? getMessage : null;
};

var range = function range(_ref3, attribute, message) {
  var value = _ref3.value,
      min = _ref3.min,
      max = _ref3.max;
  var getMessage = typeof message === 'function' ? message(attribute, value, {
    min: min,
    max: max
  }) : message;
  return value < min || value > max ? getMessage : null;
};

var passwordComplexity = function passwordComplexity(value, attribute, message) {
  var regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[-#?!@$%^&()*_. ,;']).{6,}$/; // at least one uppercase letter, one lowercase letter, one number, one special character
  // and minimal length of 6

  var getMessage = typeof message === 'function' ? message(attribute, value) : message;
  return !regex.test(value) ? getMessage : null;
};

var isString = function isString(value, attribute, message) {
  var getMessage = typeof message === 'function' ? message(attribute, value) : message;
  return typeof value !== 'string' ? getMessage : null;
};

var isInteger = function isInteger(value, attribute, message) {
  var getMessage = typeof message === 'function' ? message(attribute, value) : message;
  return !Number.isInteger(value) ? getMessage : null;
};

var matchPattern = function matchPattern(value, attribute, pattern, message) {
  if (pattern instanceof RegExp) {
    var getMessage = typeof message === 'function' ? message(attribute, value) : message;
    return !pattern.test(value) ? getMessage : null;
  }

  throw new Error('[pattern] must be an instance of RegExp.');
};

var isValidList = function isValidList(values, attribute, condition, message) {
  var indexes = values.reduce(function (acc, value, index) {
    if (!condition(value.value)) {
      acc.push(index);
    }

    return acc;
  }, []);
  var getMessage = typeof message === 'function' ? {
    message: message(attribute, values),
    indexes: indexes
  } : message;
  return indexes.length > 0 ? getMessage : null;
};

var validator = function validator(rules, values) {
  var customValidators = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return rules.reduce(function (acc, rule) {
    var attributes = rule.attributes,
        condition = rule.condition,
        compareAttribute = rule.compareAttribute,
        message = rule.message,
        customValidator = rule.customValidator,
        pattern = rule.pattern,
        listCondition = rule.listCondition,
        min = rule.min,
        max = rule.max;
    attributes.forEach(function (attribute) {
      if (Object.prototype.hasOwnProperty.call(values, attribute)) {
        if (condition === EMAIL) {
          var error = email(values[attribute], attribute, message);

          if (error) {
            acc[attribute] = [].concat((0, _toConsumableArray2.default)(acc[attribute] || []), [error]);
          }
        }

        if (condition === REQUIRED) {
          var _error = required(values[attribute], attribute, message);

          if (_error) {
            acc[attribute] = [].concat((0, _toConsumableArray2.default)(acc[attribute] || []), [_error]);
          }
        }

        if (condition === STRING) {
          var _error2 = isString(values[attribute], attribute, message);

          if (_error2) {
            acc[attribute] = [].concat((0, _toConsumableArray2.default)(acc[attribute] || []), [_error2]);
          }
        }

        if (condition === INTEGER) {
          var _error3 = isInteger(values[attribute], attribute, message);

          if (_error3) {
            acc[attribute] = [].concat((0, _toConsumableArray2.default)(acc[attribute] || []), [_error3]);
          }
        }

        if (condition === COMPARE) {
          var _error4 = compare({
            value1: values[attribute],
            value2: values[compareAttribute]
          }, {
            attribute1: attribute,
            attribute2: compareAttribute
          }, message);

          if (_error4) {
            acc[attribute] = [].concat((0, _toConsumableArray2.default)(acc[attribute] || []), [_error4]);
          }
        }

        if (condition === RANGE) {
          var _error5 = range({
            value: values[attribute],
            min: min,
            max: max
          }, attribute, message);

          if (_error5) {
            acc[attribute] = [].concat((0, _toConsumableArray2.default)(acc[attribute] || []), [_error5]);
          }
        }

        if (condition === PASSWORD_COMPLEXITY) {
          var _error6 = passwordComplexity(values[attribute], attribute, message);

          if (_error6) {
            acc[attribute] = [].concat((0, _toConsumableArray2.default)(acc[attribute] || []), [_error6]);
          }
        }

        if (condition === MATCH_PATTERN) {
          var _error7 = matchPattern(values[attribute], attribute, pattern, message);

          if (_error7) {
            acc[attribute] = [].concat((0, _toConsumableArray2.default)(acc[attribute] || []), [_error7]);
          }
        }

        if (condition === LIST) {
          var _error8 = isValidList(values[attribute], attribute, listCondition, message);

          if (_error8) {
            acc[attribute] = [].concat((0, _toConsumableArray2.default)(acc[attribute] || []), [_error8]);
          }
        } // Handle custom validator


        if (customValidators[condition]) {
          var custom = customValidators[condition];

          var _error9 = custom(values[attribute], attribute, message);

          if (_error9) {
            acc[attribute] = [].concat((0, _toConsumableArray2.default)(acc[attribute] || []), [_error9]);
          }
        } // Handle custom validator from defined validation rules


        if (customValidator) {
          var _error10 = customValidator(values[attribute], attribute, message);

          if (_error10) {
            acc[attribute] = [].concat((0, _toConsumableArray2.default)(acc[attribute] || []), [_error10]);
          }
        }
      }
    });
    return acc;
  }, {});
};

exports.validator = validator;

var isFieldRequired = function isFieldRequired() {
  var rules = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var attribute = arguments.length > 1 ? arguments[1] : undefined;
  return rules.findIndex(function (rule) {
    var attributes = rule.attributes,
        condition = rule.condition;
    return attributes.indexOf(attribute) !== -1 && condition === REQUIRED;
  }) !== -1;
};

exports.isFieldRequired = isFieldRequired;
//# sourceMappingURL=validator.js.map